import React, { Component } from 'react';
import {/*Errors, */Form, Control} from "react-redux-form";
import _ from 'lodash';
import {formatMoney} from "accounting-js";
import moment from "moment/moment";
import BigFileUpload from "../widgets/big_file_upload";
import {required} from "../field_validations";

export default class Summary extends Component {
	render(){
		let { match, modalities, reports } = this.props;
		let { summary } = reports;
		let mod = _.find(modalities.list, {slug: match.params.modality})
		let sc = _.find(reports.permissions, (o) => {return o==='Create'}) ? true:false;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<h3 className="title is-3">PROEQUIDAD</h3>
					<h6 className="subtitle is-6"><b>{mod ? `${mod.name} - ${reports.phase_group ? reports.phase_group.name:''}`:''}</b></h6>
					<hr style={{backgroundColor: '#000'}}/>
					<h1 className="title is-6">DATOS GENERALES</h1>
					<table className="table is-fullwidth project-goal-table no-margin">
						<tbody>
						<tr>
							<td colSpan={1}>
								<span className="help is-dark">Titular</span>
								<strong>{!_.isEmpty(summary.data) ? `${summary.data.agency.owner.name} ${summary.data.agency.owner.last_name} ${summary.data.agency.owner.slast_name}`:'---'}</strong>
							</td>
							<td colSpan={1}>
								<span className="help is-dark">Entidad</span>
								<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>
							</td>
						</tr>
						<tr>
							<td colSpan={2}>
								<span className="help is-dark">Instancia</span>
								<strong>{!_.isEmpty(summary.data) && summary.data.agency.name ? summary.data.agency.name : '---'}</strong>
							</td>
						</tr>
						<tr>
							<td>
								<div className="columns">
									<div className="column is-1">
										<i className="fa fa-usd fa-2x" />
									</div>
									<div className="column">
										<span className="help is-dark">Monto aprobado</span>
										<strong> {summary.data.amounts && summary.data.amounts.total ? `${formatMoney(summary.data.amounts.total)}` : '---'}</strong>
									</div>
								</div>
							</td>
							<td>
								<div className="columns">
									<div className="column is-1">
										<i className="fa fa-calendar fa-2x" />
									</div>
									<div className="column">
										<span className="help is-dark">Periodo de ejecución</span>
										<strong>{_.capitalize(moment(summary.data.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(summary.data.execution_end).format('MMMM YYYY'))}</strong>
									</div>
								</div>
							</td>
						</tr>
						</tbody>
					</table>

					<h6 className="subtitle is-6"><strong>AVANCE FÍSICO FINANCIERO</strong></h6>
					{_.map(summary.data.proigualdad_axis, (axis,k) => {
						return [
							<div key={'title-'+k} className="box">
								<p >Eje Temático</p>
								<h5 className="subtitle is-5"><strong>{axis.name}</strong></h5>
							</div>,
							<table className="table is-fullwidth project-goal-table no-margin" key={`table-`+k}>
								<thead>
								<tr>
									<th>Clave</th>
									<th>Meta</th>
									{match.params.modality === 'modalidad-iii' ?
									<th>Instancia</th>:null}
									<th>Estatus</th>
									<th>Monto aprobado</th>
									{match.params.modality === 'modalidad-iii' ?
									<th>Monto ejercido desglosado</th>:null}
									<th>Monto ejercido</th>
									<th>Monto por ejercer</th>
								</tr>
								</thead>
								<tbody>
								{_.map(axis.project_goals,(row,k) => {
									let cdmsQuantity= match.params.modality === 'modalidad-iii' ? row.project_goal_agencies.length:undefined;
									if(match.params.modality !== 'modalidad-iii'){
										return(
											<tr key={k}>
												<td className="goal-cell" style={{width: 5 +'%'}}>
													<strong>{row.code}</strong>
												</td>
												<td style={{width: 40 +'%'}}>{row.name}</td>
												<td>{row.project_version_phase_goal && row.project_version_phase_goal.status_id !== 0 && row.project_version_phase_goal.status_id !== 1 ? <strong><span className={`has-text-${row.project_version_phase_goal.status.style}`}>{row.project_version_phase_goal.status.name}</span></strong>:<span>Sin estatus</span>}</td>
												<td className="has-text-right" style={{width: 15 +'%'}}>{formatMoney(row.amounts.total)}</td>
												<td className="has-text-right" style={{width: 15 +'%'}}>{formatMoney(row.amounts.spent)}</td>
												<td className="has-text-right" style={{width: 15 +'%'}}>{formatMoney(row.amounts.missing)}</td>
											</tr>
										)
									}else {
										return (
											_.map(row.project_goal_agencies, (item, o) =>{
												return (
													<tr key={o}>
														{o===0 ?
														<td className="goal-cell" rowSpan={cdmsQuantity} style={{width: 5 +'%'}}>
															<strong>{row.code}</strong>
														</td>
														:null}
														{o===0 ?
														<td rowSpan={cdmsQuantity} style={{width: 25 +'%'}}>{row.name}</td>
														:null}
														<td >{item.agenciable && item.agenciable.name ? item.agenciable.name:'---'}</td>
														<td>{item.project_version_phase_goal && item.project_version_phase_goal.status_id !== 1 && item.project_version_phase_goal.status_id !== 0  ? <strong><span className={`has-text-${item.project_version_phase_goal.status.style}`}>{item.project_version_phase_goal.status.name}</span></strong>:<span>Sin estatus</span>}</td>
														{o===0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right" style={{width: 10 +'%'}}>{formatMoney(row.amounts.total)}</td>
														:null}
														<td className="has-text-right" style={{width: 10 +'%'}}>{formatMoney(item.amounts.spent)}</td>
														{o===0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right" style={{width: 10 +'%'}}>{formatMoney(row.amounts.spent)}</td>
														:null}
														{o===0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right" style={{width: 10 +'%'}}>{formatMoney(row.amounts.missing)}</td>
														:null}
													</tr>
												)
											})
										)
									}
								})}
								<tr>
									<td className="has-text-right goal-cell"  colSpan={match.params.modality === 'modalidad-iii' ? 4:3}>
										<strong>Total</strong>
									</td>
									<td className="has-text-right goal-cell" ><strong>{formatMoney(axis.amounts.total)}</strong></td>
									<td className="has-text-right goal-cell" colSpan={match.params.modality === 'modalidad-iii' ? 2:1}><strong>{formatMoney(axis.amounts.spent)}</strong></td>
									<td className="has-text-right goal-cell" ><strong>{formatMoney(axis.amounts.missing)}</strong></td>
								</tr>
								</tbody>
							</table>
						]
					})}

					<h6 className="subtitle is-6"><strong>GASTOS DE COORDINACIÓN Y SEGUIMIENTO DEL PROYECTO</strong></h6>
					<table className="is-fullwidth table project-goal-table no-margin">
						<thead>
						<tr>
							<th>No</th>
							<th>Concepto de gasto </th>
							{match.params.modality === 'modalidad-iii' ?
							<th>Instancia</th>:null}
							<th>Monto aprobado</th>
							{match.params.modality === 'modalidad-iii' ?
							<th>Monto ejercido desglosado</th>:null}
							<th>Monto ejercido</th>
							<th>Monto por ejercer</th>
						</tr>
						</thead>
						{!_.isEmpty(summary.data) ?
							<tbody>
							{_.map(summary.data.project_expenses, (ex, k) => {
								let cdmsQuantity= match.params.modality === 'modalidad-iii' ? _.size(ex.project_expense_agencies):undefined;
								if(match.params.modality !== 'modalidad-iii'){
									return (
										<tr key={k}>
											<td className="goal-cell"><strong>{k+1}</strong></td>
											<td><span>{ex.expense_concept.name}</span></td>
											<td className="has-text-right">
												{formatMoney(ex.amounts.total)}
											</td>
											<td className="has-text-right">
												{formatMoney(ex.amounts.spent)}
											</td>
											<td className="has-text-right">
												{formatMoney(ex.amounts.missing)}
											</td>
										</tr>
									)
								}else {
									if(!_.isEmpty(ex.project_expense_agencies)){
										return (
											_.map(ex.project_expense_agencies, (item, o) => {
												return (
													<tr key={o}>
														{o === 0 ?
														<td className="goal-cell" rowSpan={cdmsQuantity}>
															<strong>{k+1}</strong>
														</td>
														:null}
														{o === 0 ?
														<td rowSpan={cdmsQuantity}>
															<span>{ex.expense_concept.name}</span>
														</td>
														:null}
														<td>
															<span>{item.agenciable.name}</span>
														</td>
														{o === 0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right">
															{formatMoney(ex.amounts.total)}
														</td>
														:null}
														<td className="has-text-right">
															{formatMoney(item.amounts.spent)}
														</td>
														{o === 0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right">
															{formatMoney(ex.amounts.spent)}
														</td>
														:null}
														{o === 0 ?
														<td rowSpan={cdmsQuantity} className="has-text-right">
															{formatMoney(ex.amounts.missing)}
														</td>
														:null}
													</tr>
												)
											})
										)
									}else {
										return (
											<tr key={k}>
												<td className="goal-cell"><strong>{k+1}</strong></td>
												<td><span>{ex.expense_concept.name}</span></td>
												<td><span>---</span></td>
												<td className="has-text-right">
													{formatMoney(ex.amounts.total)}
												</td>
												<td className="has-text-right"><strong></strong></td>
												<td className="has-text-right">
													{formatMoney(ex.amounts.spent)}
												</td>
												<td className="has-text-right">
													{formatMoney(ex.amounts.missing)}
												</td>
											</tr>
										)
									}
								}
							})}
							<tr>
								<td className="has-text-right goal-cell"  colSpan={match.params.modality === 'modalidad-iii' ? 3:2}>
									<strong>Total</strong>
								</td>
								<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data ? summary.data.amounts.expenses.total:0)}</strong></td>
								<td className="has-text-right goal-cell" colSpan={match.params.modality === 'modalidad-iii' ? 2:1} ><strong>{formatMoney(summary.data ? summary.data.amounts.expenses.spent:0)}</strong></td>
								<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data ? summary.data.amounts.expenses.missing:0)}</strong></td>
							</tr>
							</tbody>
							:
							<tbody>
							<tr>
								<td>Ningún gasto de coordinación encontrado</td>
							</tr>
							</tbody>}
					</table>

					<h6 className="subtitle is-6"><strong>RESUMEN DE AVANCE FÍSICO FINANCIERO</strong></h6>
					<table className="is-fullwidth table project-goal-table no-margin">
						<thead>
						<tr>
							<th>Eje temático</th>
							<th>Metas</th>
							<th>Monto aprobado</th>
							<th>Monto ejercido</th>
							<th>Monto por ejercer</th>
						</tr>
						</thead>
						<tbody>
						{_.map(summary.data.proigualdad_axis,(axis,k) => {
							return(
								<tr key={k}>
									<td style={{width: 50+'%'}}>{axis.name}</td>
									<td>{axis.project_goals.length}</td>
									<td className="has-text-right" style={{width: 15+'%'}}>{formatMoney(axis.amounts.total)}</td>
									<td className="has-text-right" style={{width: 15+'%'}}>{formatMoney(axis.amounts.spent)}</td>
									<td className="has-text-right" style={{width: 15+'%'}}>{formatMoney(axis.amounts.missing)}</td>
								</tr>
							)
						})}
						<tr>
							<td className="has-text-right goal-cell"  colSpan={2}><strong>Subtotal</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.goals.total:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.goals.spent:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.goals.missing:0)}</strong></td>
						</tr>
						<tr>
							<td className="goal-cell" ><strong>Gastos de Coordinación</strong></td>
							<td className="has-text-right goal-cell" ><strong>Subtotal</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.expenses.total:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.expenses.spent:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.expenses.missing:0)}</strong></td>
						</tr>
						<tr>
							<td className="has-text-right goal-cell"  colSpan={2}><strong>Total del proyecto</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.total:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.spent:0)}</strong></td>
							<td className="has-text-right goal-cell" ><strong>{formatMoney(summary.data && summary.data.amounts ? summary.data.amounts.missing:0)}</strong></td>
						</tr>
						</tbody>
					</table>

					<Form model="reports.summary.edit" onSubmit={(values) => this._submitForm(values)}>
						<div className="message is-success">
							<div className="message-body">
								<div className="field">
									<div className="control">
										<label htmlFor="finished" className="checkbox">
											<Control.checkbox model=".finished" id="finished" value={summary.edit.finished ? true:false} className="checkbox"/>
											{/* <span style={{whiteSpace:'normal'}}>{`Certifico que cuento con los Comprobantes Fiscales Digitales por Internet (CFDI) correspondientes al ejercicio del gasto y que la información que he proporcionado a través de este instrumento es correcta y se encuentra completa; que conozco las disposiciones establecidas en el Acuerdo por el que se emiten las Reglas de Operación de ProEquidad, para el ejercicio fiscal ${reports.version ? reports.version.year:'----'}, respecto a la Auditoría, Control y Seguimiento del Programa, proyectos y recursos. Que he leído el párrafo donde se señala que "...las instancias de auditoría y control, en el ámbito de sus respectivas competencias, podrán promover la aplicación de las sanciones correspondientes con fundamento en la Ley Federal de Responsabilidades Administrativas de los Servidores Públicos."`}</span> */}
											<span style={{whiteSpace:'normal'}}>{`“Certifico que cuento con los Comprobantes Fiscales Digitales por Internet (CFDI) correspondientes al ejercicio del gasto y que la información que he proporcionado a través de este instrumento es correcta y se encuentra completa; que conozco las disposiciones establecidas por el que se emiten las Bases de Participación del Proequidad, para el ejercicio fiscal ${reports.version ? reports.version.year:'----'}, respecto a la Auditoría, Control y Seguimiento del mismo, proyectos y recursos. Que he leído apartado “16. Obligaciones de las IMEF para la ejecución de los proyectos beneficiados”`}</span>
										</label>
									</div>
								</div>
								<br/>

								<div className="level">
									<div className="level-left">
										<div className="level-item">
											<div>
												<p>Titular de la instancia</p>
												<h1 className="title is-5">{!_.isEmpty(summary.data) ? `${summary.data.agency.owner.name} ${summary.data.agency.owner.last_name} ${summary.data.agency.owner.slast_name}`:'---'}</h1>
											</div>
										</div>
									</div>

									<div className="level-right">
										<div className="level-item">
											<div className="control">
												<button type="button" className="button is-info" onClick={() => this._getExport()} disabled={summary.edit.finished ? false:true}>
													<span className="icon"><i className="fa fa-link" /></span>
													<span>Generar documento para impresión</span>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{summary.data ?
							_.map(summary.data.documents_items, (item, d) => {
								let summaryRevision = !_.isEmpty(reports.summary.revision.body) && !_.isEmpty(reports.summary.revision.body[item.id]) ? reports.summary.revision.body[item.id]: undefined
								let summaryRevisionAllowEdit = summaryRevision && !_.isEmpty(summaryRevision.allow_edit) ? (summaryRevision.allow_edit === 'true' ? true:false):undefined;
								let validEditSummary = sc ? (summaryRevision && summaryRevisionAllowEdit !== undefined  ? summaryRevisionAllowEdit:(summaryRevision && summaryRevisionAllowEdit === undefined ? false:sc)):false;
								return (
									<div className="box" key={d}>
										<h1 className="title is-5">{item.name}</h1>
										{summary.edit.finished ?
											<div className="columns">
												<div className="column is-6">
													<p className="has-text-right">{item.description}</p>
													<br/>
													{item.file_format ?
													<div className="field is-grouped is-grouped-right">
														<div className="control">
															<a target="_blank" className="button is-info" href={item.file_format} disabled={summary.edit.finished ? false:true}>
																<span className="icon"><i className="fa fa-link" /></span>
																<span>Descargar formato</span>
															</a>
														</div>
													</div> :''}
												</div>

												<div className="column is-6">
													<BigFileUpload
														model={`.${item.slug}`}
														name={`Guardar ${item.name}`}
														file={summary.edit[item.slug]}
														status="primary"
														validators={{required}}
														disabled={validEditSummary ? false:true}
														message={{required: 'Falta anexar documento'}}
													/>
												</div>
											</div>
											:''}
										{summary.edit.finished && summaryRevision && summaryRevision.comment ?
											<div className={`notification ${summaryRevision.status ? `is-${summaryRevision.status}`:''}`}>
												<i className="fa fa-info"/>&nbsp;
												{summaryRevision.comment}
											</div> :''}
									</div>
								)
							})
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button className="button is-large" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{sc ?
							<div className="control">
								<Control.button model="reports.summary.edit" className="button is-large is-primary" disabled={summary.data.editable ? false:true}>Guardar</Control.button>
							</div>
							:''}
						</div>
					</Form>

				</div>
			</div>
		)
	}

	_submitForm(values){
		const {modality, state, municipality} = this.props.match.params;
		this.props.reportsSummarySave(values, modality, state, municipality);
	}

	_getExport(){
		const {modality, state, municipality} = this.props.match.params;
		this.props.reportsSummaryExport(modality, state, municipality);
	}
}


// WEBPACK FOOTER //
// ./src/elements/reports/summary.jsx